<template>
  <div>
    <div class="container">
      <div class="row d-flex justify-content-center mt-10 mb-10">
        <div class="col-lg-9">
          <card-component :title="$t('messages.form.title')" :loading="loading">
            <b-card-text>
              <h1>Bem-vindo <span>à PagBrasil</span></h1>
              <personal-form-component
                @loading="updateLoading"
                :formSession="false"
              ></personal-form-component>
            </b-card-text>
          </card-component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CardComponent from "@/components/Form/CardComponent";
import PersonalFormComponent from "@/components/Form/PersonalFormComponent";

export default {
  name: "AccessPage",
  components: {
    CardComponent,
    PersonalFormComponent,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    updateLoading: function(status) {
      this.loading = status;
    },
  }
};
</script>
